import AnalysisCategory from 'views/Analysis/AnalysisCategory';
import { Areas } from 'constants/constants';
import { AnalysisKinds, ComparisonKinds } from 'views/Analysis/analysisUtils';

// 分析（重点エリア）
function AnalysisArea(props) {
  // 分析情報
  const analysisList = props.quoteList;
  // 選択中の期
  const selectedPeriod = props.selectedPeriod;
  // 分析種別
  const analysisKind = AnalysisKinds.find((x) => x.key == props.analysisKind);
  // 比較種別
  const comparisonKind = ComparisonKinds.find((x) => x.key == props.comparisonKind);

  // 集計項目
  const summaryItems = Areas.filter((x) => x.key)
    .map((x) => ({
      key: `AREA_${x.key}`,
      label: x.value,
      important: x.important,
    }))
    .sort((a, b) => {
      return (b.important === true ? 1 : 0) - (a.important === true ? 1 : 0);
    });

  // ヘッダー
  const categoryHeader = [
    { category: '重点エリア', start: 1, end: 14 },
    { category: '高崎市外', start: 15, end: 22 },
  ];

  return (
    <AnalysisCategory
      analysisList={analysisList}
      selectedPeriod={selectedPeriod}
      summaryItems={summaryItems}
      analysisKind={analysisKind}
      categoryHeader={categoryHeader}
      comparisonKind={comparisonKind}
      categoryName="重点エリア＋高崎市外別"
    />
  );
}
export default AnalysisArea;
